import { Paper } from '@mui/material'
import React, { useEffect } from 'react'

import MainTitle from "../../modules/shared/components/MainTitle"
import { resetAssociado } from '../../store/reducers/associadoSlice'
import { resetAssociadoSelecionado } from '../../store/reducers/associadoSelecionadoSlice'
import { resetLocalizacao } from '../../store/reducers/localizacaoSlice'
import { resetOcorrencia } from '../../store/reducers/ocorrenciaSlice'
import { resetOcorrenciaSelecionada } from '../../store/reducers/ocorrenciaSelecionadaSlice'
import { resetUsuario } from '../../store/reducers/usuarioSlice'
import { useDispatch } from 'react-redux'
import { useDisplayAlertAfterServerResponse } from '../../modules/shared/hooks/useDisplayAlertAfterServerResponse/useDisplayAlertAfterServerResponse'
import { useCadastraAssociadoADM } from '../../modules/associado/hooks/useCadastraAssociadoADM'
import FormCadastraAssociadoADM from '../../modules/associado/components/FormCadastraAssociadoADM/FormCadastraAssociadoADM'

export default function CadastrarAssociadoADM() {
    
    const [resposta, cadastrarAssociadoADM] = useCadastraAssociadoADM()
    useDisplayAlertAfterServerResponse(resposta)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(resetAssociado())
        dispatch(resetAssociadoSelecionado())
        dispatch(resetLocalizacao())
        dispatch(resetOcorrencia())
        dispatch(resetOcorrenciaSelecionada())
        dispatch(resetUsuario())
    }, [dispatch])

    return (
        <Paper>
            <MainTitle titulo={"Cadastrar associado"} tituloPrincipal={true} />
            <FormCadastraAssociadoADM aoSubmeterForm={cadastrarAssociadoADM} editButton={true} />
        </Paper>
    )
}